import { API_BASE_URL } from './globalConstants'
import axios from 'axios';
const service = axios.create({
    baseURL: API_BASE_URL,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
        "Accept-Language":localStorage.getItem('LANG')
    },
    method: 'POST',
});
const whitelist = ['/login']; // 在白名单内的接口不需要加token
service.interceptors.request.use(
    async  (config) => {
        // 获取当前请求的url
        const requestUrl = config.url;
        // 检查当前请求的url是否在白名单内
        const isInWhitelist = whitelist.some((path) => requestUrl.includes(path));
        // 如果不在白名单内，添加token
        if (!isInWhitelist) {
            const TOKEN = localStorage.getItem('TOKEN');
            if (TOKEN) {
                config.headers['Authorization'] = TOKEN;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
// service.interceptors.response.use(
//     (response) => {
//         debugger
//         return response;
//     },
//     (error) => {
//         // 获取错误回调
//         const errorResponse = error.response;

//         // 检查是否是特定错误，比如 token 错误
//         if (errorResponse && errorResponse.status === 401) {
//             // 在这里执行清除 token 的操作
//             localStorage.removeItem('TOKEN');
//         }

//         // 将错误继续传递，可以在调用方处理
//         return Promise.reject(error);
//     }
// );

export default service;
